<section *ngIf="workflow.workflowId" class="bg-anuprerna-200 text-anuprerna-250 font-mulish min-h-s vh m-0 p-0">
	<section class="max-w-4xl mx-auto px-3 py-2 bg-white shadow-md rounded-lg mt-6 mb-6">
		<!--		<h3 class="text-sm md:text-base font-semibold mb-4">Production Progress - {{(product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.name : product.customization.fabricProductPreview!.product.name)}}</h3>-->

		<div class="">

			<ng-container *ngFor="let step of workflow.steps">

				<div class="border rounded-lg p-4 mt-3">
					<div class="flex justify-between items-center gap-4">
						<h4 class="font-semibold ">{{step.stepName}}</h4>
						<div class="flex-grow">
							<div class="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden">
								<div class="absolute top-0 left-0 h-full bg-anuprerna-100" [style]="'width:'+ step.stepProgress +'%;'" ></div>
							</div>
						</div>
						<div *ngIf="step.stepStatus !== 'COMPLETED' && step.stepProgress" class="text-xs">{{step.stepProgress.toFixed(1)}}%</div>
						<div *ngIf="step.stepStatus === 'COMPLETED' && step.stepProgress" class="text-xs">Completed</div>
					</div>
				</div>

				<div *ngIf="step.subProcesses && step.subProcesses.length > 0" class="flex text-center mb-7">
					<img src="assets/img/arrow-sub.svg" alt="arrow" class="h-10 md:h-14 w-10 md:w-14 ml-4 md:ml-10">
					<div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-8">
						<div class="relative flex flex-row justify-center sm:justify-start items-stretch"
							 *ngFor="let subProcess of step.subProcesses"
							 [ngClass]="subProcess.subProcessStatus === 'COMPLETED'? 'f-step-done': (subProcess.subProcessStatus === 'IN_PROGRESS'? 'f-step-in-progress':'')">
							<div class="flex flex-col items-center justify-start">
								<div class="flex flex-col items-center" >
									<div *ngIf="subProcess.subProcessStatus === 'COMPLETED'"
										 class="mt-2 sm:mt-8 h-8 w-8 bg-anuprerna-10 rounded-full flex items-center justify-center text-anuprerna-250 text-xs">
										<span class="material-symbols-outlined">check</span>
									</div>
									<div *ngIf="subProcess.subProcessStatus === 'IN_PROGRESS'"
										 class="mt-2 sm:mt-8 h-8 w-8 bg-anuprerna-20 rounded-full flex items-center justify-center text-anuprerna-250 text-xs">
										<span class="material-symbols-outlined">cached</span>
									</div>
									<div *ngIf="subProcess.subProcessStatus === 'PENDING' || subProcess.subProcessStatus === 'HALTED'"
										 class="mt-2 sm:mt-8 h-8 w-8 bg-anuprerna-200 rounded-full flex items-center justify-center text-anuprerna-250 text-xs">
										<span class="material-symbols-outlined">hourglass_top</span>
									</div>
									<div class="text-xs mt-2">
										<span>{{subProcess.subProcessName}}</span>
									</div>
								</div>
								<div *ngIf="!loading && subProcess.hasApprovedFeedback" class="mt-2 max-w-[140px]">
									<ng-container *ngIf="subProcess.elementFeedback">
										<p class="text-xs text-left my-2">{{subProcess.elementFeedback.text? subProcess.elementFeedback.text: ''}}</p>

										<div *ngIf="subProcess.elementFeedback.image && subProcess.elementFeedback.images.length > 0"
											 class="grid grid-cols-4 gap-0.5">
											<a *ngFor="let image of subProcess.elementFeedback.images"
											   (click)="trackMediaView(image, 'Image')"
											   [href]="cdnLink + image"
											   target="_blank">
												<img class="w-[30px] h-[30px] object-cover rounded" [src]="cdnLink + image" alt="">
											</a>
										</div>
										<div *ngIf="subProcess.elementFeedback?.video"
											 class="grid grid-cols-4 gap-0.5 mt-4">
											<a *ngFor="let video of subProcess.elementFeedback?.videosUrl"
											   (click)="trackMediaView(video, 'Video')"
											   [href]="cdnLink + video"
											   target="_blank">
												<img class="w-[30px] h-[30px] object-contain rounded"
													 [src]="'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/bpm-feedback/play.png'" alt="">
											</a>
										</div>
									</ng-container>
								</div>
							</div>
						</div>
					</div>

				</div>

			</ng-container>

		</div>

	</section>
</section>

